export default __webpack_public_path__ + "static/media/dessert-1.1941dd70.jpg";